import { useFeatureFlagQuery } from 'remote-state/featureFlagsHooks';
import { FEATURE_FLAGS_KEYS } from 'constants/featureFlags';

const useIsGridPaginationEnabled = () => {
    const { data: isGridPaginationEnabled } = useFeatureFlagQuery({
        flagKey: FEATURE_FLAGS_KEYS.GRID_PAGINATION,
        defaultValue: false,
    });
    return isGridPaginationEnabled;
}

export default useIsGridPaginationEnabled;